module.exports = __webpack_public_path__ + "img/underline-text.caa571a0.png";